export default {
  computed: {
    isAuthenticated() {
      return this.$role.verify([
        this.$role.MERCHANT_ADMIN,
        this.$role.VIEW_PAYMENT_REQUESTS,
        this.$role.STANDARD_PAYMENT_REQUEST,
        this.$role.SEND_RECURRING_PAYMENT_REQUEST
      ]);
    },
    canViewPaymentRequests() {
      return this.$role.verify([
        this.$role.VIEW_PAYMENT_REQUESTS,
        this.$role.MERCHANT_ADMIN
      ]);
    },
    canCreateStandardPaymentRequest() {
      return this.$role.verify([
        this.$role.STANDARD_PAYMENT_REQUEST,
        this.$role.MERCHANT_ADMIN
      ]);
    },
    canCreateRecurringPaymentRequest() {
      let roleVerified = this.$role.verify([
        this.$role.SEND_RECURRING_PAYMENT_REQUEST,
        this.$role.MERCHANT_ADMIN
      ]);
      let recurringFeatureEnabled = this.$store.getters.verifyFeature(
        this.$role.FEATURES.RECURRING_PAYMENT_REQUEST
      );
      return roleVerified && recurringFeatureEnabled;
    }
  }
};
